import type { Location } from 'modules/core/lib/navigation/types'
import { navigation as incentives } from 'modules/incentives/lib/navigation'

export const navigation = {
  path: 'compensations',
  children: {
    cycles: {
      path: 'cycles',
      children: {
        list: {
          path: 'list',
          size: 'full',
        },
        id: {
          path: ':id',
          level: 2,
          children: {
            importCompensations: {
              path: 'import-compensations/*',
              size: 'full',
              level: 2,
            },
            importResult: {
              path: 'import-result',
              size: 'full',
            },
            payments: {
              path: 'payments',
              size: 'full',
            },
          },
        },
      },
    },
    definition: {
      size: 'full',
      path: 'definition',
      children: {
        importCompensations: {
          path: 'import-compensations/*',
          size: 'full',
          level: 2,
        },
        importResult: {
          path: 'import-result',
          size: 'full',
        },
      },
    },
    employeeUpdates: {
      size: 'full',
      path: 'employee-updates',
      children: {
        id: {
          size: 'full',
          path: ':id',
        },
        idChanges: {
          size: 'full',
          path: ':id/changes',
        },
        idMessages: {
          size: 'full',
          path: ':id/messages',
        },
        idAll: {
          size: 'full',
          path: ':id/*',
        },
        idNotes: {
          size: 'full',
          path: ':id/notes',
        },
      },
    },
    payrollUpdatesLanding: {
      size: 'full',
      path: 'incidences-landing',
    },
    inhouseActivation: {
      size: 'full',
      path: 'inhouse-activation',
    },
    timeReimbursement: {
      size: 'full',
      path: 'time-reimbursement',
    },
    expensesReimbursement: {
      size: 'full',
      path: 'expenses-reimbursement',
    },
    incentives,
  },
} as const satisfies Location
